// extracted by mini-css-extract-plugin
module.exports = {"tags-table":"printtag_tags-table__1404L"};